import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/icon/iconfont.css"
import api from "./api/api"
import Pagination from "@/components/Pagination";
import '@wangeditor/editor/dist/css/style.css'


// import 'lib-flexible'
Vue.prototype.$api = api
Vue.use(ElementUI);
import Echarts from 'echarts'
Vue.prototype.$echarts = Echarts
Vue.use(Echarts)
// import pdf from 'pdfobject'
// Vue.prototype.$pdf=pdf
Vue.config.productionTip = false
Vue.component('Pagination', Pagination)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// const whiteList = ['/', '/404']


router.beforeEach(async (to, from, next) => {
  // console.log(to, from)
  //to and from are Route Object,next() must be called to resolve the hook}
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (sessionStorage.getItem('token')) {
    if (to.path == '/') {
      next('/index')
    } else if (sessionStorage.getItem('token')) {
      next()
    }
  } else {
    next();
    // else {
    //   Vue.prototype.$message({
    //     message: '请先登录',
    //     type: 'warning'
    //   })
    //   next({ path: '/' })
    // }
  }


})
